import { amplifyClient, getEndpointV2 } from 'api';
import { createApiSlice } from 'helpers/createApiSlice';
import { getMartePagination } from 'helpers/pagination';
import { call } from 'redux-saga/effects';
import {
  ApiStateData,
  AppNotification,
  DataWithPagination,
  MakerSelectors,
  Pagination,
} from 'types';

type Data = DataWithPagination<AppNotification>;

type Payload = {
  page: number;
};

interface ExtraSelectors extends MakerSelectors<ApiStateData<Data>> {
  getData: (d: ApiStateData<Data>) => Array<AppNotification>;
  getPagination: (d: ApiStateData<Data>) => Pagination | undefined;
}

export const notificationsFetch = createApiSlice<Data, Payload, ExtraSelectors>({
  name: 'notificationsFetch',
  *tryGenerator(_, { payload }) {
    const { page } = payload || {};

    const out: Data = yield call(amplifyClient, {
      method: 'get',
      url: getEndpointV2({ path: '/notifmanager/notifications', params: { page } }),
    });

    return out;
  },
  extraSelectors: {
    getData: (data) => data?.pageObjects || [],
    getPagination: (data) => getMartePagination(data),
  },
});
